import { useQuery } from 'react-query';
import { get } from '@xmatters/redux/services/httpService';

export function useGetEventCreatedAt(eventUuid) {
  const query = useQuery(
    `events/${eventUuid}`,
    () =>
      get({
        uri: `/api/xm/1/events/${eventUuid}`,
      }),
    {
      enabled: !!eventUuid,
    },
  );

  return query.data?.created;
}
